export interface Movie {
  id: string;
  title: string;
  year: number;
  category: string;
  subcategory: string;
  rating: number;
  duration: string;
  director: string;
  cast: string[];
  description: string;
  longDescription: string;
  coverImage: string;
  bannerImage: string;
  isHot: boolean;
  isNew: boolean;
  quality: string;
  region: string;
}

export const movieCategories = [
  { slug: 'all', name: '全部', icon: 'ri-movie-line' },
  { slug: 'huayu', name: '华语电影', icon: 'ri-china-railway-line' },
  { slug: 'oumei', name: '欧美电影', icon: 'ri-earth-line' },
  { slug: 'rihan', name: '日韩电影', icon: 'ri-sun-line' },
  { slug: 'dongzuo', name: '动作片', icon: 'ri-swap-box-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-happy-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-2-line' },
  { slug: 'jilu', name: '纪录片', icon: 'ri-camera-lens-line' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '流浪地球3',
    year: 2025,
    category: 'huayu',
    subcategory: '科幻片',
    rating: 9.2,
    duration: '148分钟',
    director: '郭帆',
    cast: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    description: '太阳急速老化，持续膨胀，一百年后将吞没地球。人类在地球表面建造出巨大的推进器，带着地球踏上长达2500年的未知宇宙之旅。',
    longDescription: '在不远的未来，太阳急速老化，持续膨胀，一百年后将吞没地球。为了应对这场灭顶之灾，人类在地球表面建造出巨大的推进器，带着地球踏上长达2500年的未知宇宙之旅。在这场跨越时空的壮丽旅程中，人类面临前所未有的挑战与抉择。影片以宏大的宇宙世界观、震撼的视觉特效与深厚的情感内核，展现了中国科幻电影的顶级制作水准。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%20style%2C%20futuristic%20space%20with%20Earth%20and%20massive%20engines%2C%20dramatic%20lighting%2C%20epic%20cinematic%20vibe%2C%20dark%20blue%20and%20orange%20tones%2C%20professional%20movie%20poster%20design%20with%20Chinese%20aesthetic&width=600&height=900&seq=movie-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20cinematic%20landscape%20of%20Earth%20in%20space%20with%20massive%20plasma%20engines%2C%20stars%20and%20nebula%20background%2C%20dramatic%20atmospheric%20lighting%2C%20dark%20tones%2C%20cinematic%20photography%2C%20professional%20movie%20visual&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    isHot: true,
    isNew: true,
    quality: '4K',
    region: '中国大陆',
  },
  {
    id: 'movie-2',
    title: '哪吒之魔童闹海',
    year: 2025,
    category: 'huayu',
    subcategory: '动画片',
    rating: 9.5,
    duration: '143分钟',
    director: '饺子',
    cast: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩'],
    description: '天劫之后，哪吒与敖丙灵魂虽存但肉身已毁，太乙真人欲用七色宝莲助二人重塑肉身，然而四海龙王却率领虾兵蟹将前来复仇。',
    longDescription: '天劫之后，哪吒与敖丙的灵魂虽存但肉身已毁，太乙真人欲用七色宝莲助二人重塑肉身。然而四海龙王却率领虾兵蟹将前来复仇，一场关乎陈塘关命运的终极之战即将爆发。哪吒与敖丙在七色宝莲的帮助下重塑肉身，但过程中却遭遇重重困难。两人必须携手面对四海龙王的复仇，守护陈塘关的和平与安宁。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20mythological%20boy%20warrior%20with%20flaming%20wheels%20and%20red%20ribbon%2C%20epic%20ancient%20Chinese%20mythology%20art%20style%2C%20vibrant%20red%20and%20gold%20colors%2C%20dynamic%20action%20pose&width=600&height=900&seq=movie-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20mythological%20fantasy%20scene%2C%20young%20warrior%20with%20magical%20flames%20flying%20above%20ancient%20Chinese%20city%2C%20golden%20and%20crimson%20aesthetic%2C%20epic%20animation%20film%20style%2C%20dramatic%20clouds%20and%20magical%20energy&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    isHot: true,
    isNew: false,
    quality: '蓝光',
    region: '中国大陆',
  },
  {
    id: 'movie-3',
    title: '速度与激情12',
    year: 2025,
    category: 'oumei',
    subcategory: '动作片',
    rating: 8.7,
    duration: '141分钟',
    director: '路易斯·莱特里尔',
    cast: ['范·迪塞尔', '杰森·斯坦森', '米歇尔·罗德里格兹', '泰瑞斯·吉布森'],
    description: '唐老大和他的家人们面对迄今为止最危险的敌人，一个从过去阴影中浮现的致命威胁，他们必须再次团结起来拯救他们所珍视的一切。',
    longDescription: '唐老大和他的家人们面对迄今为止最危险的敌人，一个从过去阴影中浮现的致命威胁。为了对抗这个敌人，他们必须再次团结起来，在全世界展开一场惊心动魄的追逐战。从洛杉矶的街头到东京的霓虹之夜，从摩洛哥的沙漠到南极的冰原，速度与激情家族将在全球最壮丽的背景下完成最惊险的特技挑战。',
    coverImage: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%20with%20fast%20cars%20and%20muscular%20cast%2C%20explosive%20street%20racing%20scene%2C%20orange%20and%20teal%20color%20grading%2C%20cinematic%20lighting%2C%20modern%20blockbuster%20aesthetic&width=600&height=900&seq=movie-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=High-speed%20car%20chase%20through%20neon%20city%20streets%20at%20night%2C%20fast%20sports%20cars%2C%20dramatic%20lighting%20with%20motion%20blur%2C%20orange%20and%20teal%20cinematic%20colors%2C%20explosive%20Hollywood%20action%20style&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    isHot: true,
    isNew: true,
    quality: '4K',
    region: '美国',
  },
  {
    id: 'movie-4',
    title: '人生大事',
    year: 2024,
    category: 'huayu',
    subcategory: '剧情片',
    rating: 9.0,
    duration: '112分钟',
    director: '刘江江',
    cast: ['朱一龙', '杨恩又', '王戈', '刘陆'],
    description: '殡葬师莫三妹遇见了孤儿武小文，两个完全不同的灵魂因为一场葬礼相遇，在一地鸡毛的平凡日子里，他们互相温暖彼此。',
    longDescription: '殡葬师莫三妹在刑满释放后经营着一家殡葬店，他在一次出殡中遇见了孤儿武小文。两个完全不同的灵魂因为一场葬礼相遇，在一地鸡毛的平凡日子里，他们互相温暖彼此，最终找到人生的意义与温度。影片以幽默温情的笔触探讨生死议题，让观众在笑泪交织中思考人生的真谛。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20movie%20poster%2C%20warm%20emotional%20story%20about%20funeral%20director%20and%20orphan%20girl%2C%20soft%20natural%20lighting%2C%20everyday%20life%20scenes%2C%20gentle%20warm%20tones%2C%20touching%20family%20drama%20aesthetic&width=600&height=900&seq=movie-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Warm%20everyday%20Chinese%20street%20scene%20with%20small%20shops%20and%20neighborhood%20life%2C%20golden%20sunset%20light%2C%20nostalgic%20atmosphere%2C%20gentle%20emotional%20cinematography%2C%20human%20connection%20story%20visual&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '超清',
    region: '中国大陆',
  },
  {
    id: 'movie-5',
    title: '名侦探柯南：百万美元的五棱星',
    year: 2025,
    category: 'rihan',
    subcategory: '动画片',
    rating: 8.9,
    duration: '110分钟',
    director: '永冈智佳',
    cast: ['高山南', '山崎和佳奈', '小山力也', '山口胜平'],
    description: '柯南一行人来到北海道函馆，被卷入了一场围绕着传说中宝藏的巨大阴谋之中，怪盗基德也现身了。',
    longDescription: '柯南、小兰、毛利小五郎一行人来到北海道函馆，被卷入了一场围绕着传说中宝藏的巨大阴谋之中。怪盗基德也现身了，这次他的目标是一颗名为「五棱星」的珍贵宝石。在北海道美丽的雪景中，一场智力与勇气的对决即将展开，柯南与基德将在这座历史古城中上演精彩的推理对决。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20detective%20movie%20poster%2C%20boy%20detective%20with%20glasses%20in%20winter%20setting%2C%20Hokkaido%20snow%20background%2C%20mystery%20theme%2C%20cool%20blue%20and%20white%20color%20palette%2C%20anime%20film%20poster%20design&width=600&height=900&seq=movie-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Beautiful%20Hokkaido%20winter%20landscape%20with%20snow-covered%20traditional%20buildings%20at%20sunset%2C%20mysterious%20atmosphere%2C%20anime-style%20scenery%2C%20cool%20blue%20and%20warm%20gold%20lighting%2C%20cinematic%20Japanese%20animation%20background&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    isHot: false,
    isNew: true,
    quality: '蓝光',
    region: '日本',
  },
  {
    id: 'movie-6',
    title: '蜘蛛侠：平行宇宙3',
    year: 2025,
    category: 'oumei',
    subcategory: '动画片',
    rating: 9.3,
    duration: '140分钟',
    director: '乔伊姆·多斯·桑托斯',
    cast: ['沙梅克·摩尔', '海莉·斯坦菲尔德', '杰克·约翰逊', '奥斯卡·伊萨克'],
    description: '迈尔斯·莫拉莱斯踏上了穿越多重宇宙的新冒险，面对更强大的敌人和更艰难的抉择，他必须超越自己成为真正的蜘蛛侠。',
    longDescription: '迈尔斯·莫拉莱斯踏上了穿越多重宇宙的新冒险，面对更强大的敌人和更艰难的抉择。在多重宇宙的边界不断瓦解的危机中，迈尔斯必须联合来自不同宇宙的蜘蛛侠们，共同对抗前所未有的威胁。这部影片以上千种独特的动画风格，为观众呈现了一场前所未有的视觉盛宴。',
    coverImage: 'https://readdy.ai/api/search-image?query=Comic%20book%20style%20animated%20spider-man%20movie%20poster%2C%20multi-verse%20theme%20with%20bold%20graphic%20design%2C%20vibrant%20colors%20and%20halftone%20patterns%2C%20urban%20cityscapes%2C%20dynamic%20comic%20book%20action%20pose&width=600&height=900&seq=movie-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Abstract%20comic%20book%20multi-verse%20cityscape%20with%20bold%20graphic%20colors%2C%20halftone%20dots%20and%20ben-day%20patterns%2C%20vibrant%20neon%20city%20buildings%2C%20pop%20art%20style%2C%20animated%20film%20aesthetic&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    isHot: false,
    isNew: true,
    quality: '4K',
    region: '美国',
  },
  {
    id: 'movie-7',
    title: '封神第二部：战火西岐',
    year: 2025,
    category: 'huayu',
    subcategory: '奇幻片',
    rating: 8.5,
    duration: '150分钟',
    director: '乌尔善',
    cast: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    description: '大商二王子殷寿带领大军讨伐西岐，西岐少主姬发在姜子牙等人的帮助下，与强大的商军展开了一场惊天对决。',
    longDescription: '大商二王子殷寿带领大军讨伐西岐，太师闻仲率魔家四将等众多奇人异士在朝歌城外摆下十绝阵。西岐少主姬发在姜子牙等人的帮助下，与强大的商军展开了一场惊心动魄的较量。影片以瑰丽奇幻的视觉特效、宏大的史诗格局和深厚的历史文化底蕴，展现了中国古典神话的动人魅力。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20mythology%20movie%20poster%2C%20ancient%20warriors%20in%20armor%20with%20mythical%20creatures%2C%20dramatic%20battle%20scene%2C%20bronze%20and%20gold%20color%20palette%2C%20epic%20Chinese%20mythological%20aesthetic&width=600&height=900&seq=movie-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20with%20warriors%20and%20mythical%20beasts%2C%20dramatic%20smoke%20and%20fire%2C%20bronze%20age%20weapons%20and%20armor%2C%20cinematic%20fantasy%20lighting%2C%20grand%20scale%20historical%20epic%20scene&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    isHot: true,
    isNew: false,
    quality: '4K',
    region: '中国大陆',
  },
  {
    id: 'movie-8',
    title: '年会不能停',
    year: 2024,
    category: 'huayu',
    subcategory: '喜剧片',
    rating: 8.8,
    duration: '117分钟',
    director: '董润年',
    cast: ['大鹏', '白客', '庄达菲', '王迅'],
    description: '钳工胡建林阴差阳错被调入集团总部成为金领，在年会上他决定揭露公司内部的层层腐败，引发了一系列啼笑皆非的故事。',
    longDescription: '钳工胡建林在集团裁员之际阴差阳错被调入集团总部，人力资源部的马杰与外包公司的潘怡然夹在层层领导中身不由己。在集团年会上，胡建林决定揭露公司内部的层层腐败，引发了一场啼笑皆非却又发人深省的职场风暴。影片以犀利的幽默讽刺了当代职场乱象，充满共鸣与笑点。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20workplace%20comedy%20movie%20poster%2C%20office%20workers%20in%20suits%20with%20funny%20expressions%2C%20bright%20colorful%20corporate%20setting%2C%20comedic%20tone%2C%20modern%20Chinese%20urban%20aesthetic&width=600&height=900&seq=movie-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20corporate%20office%20building%20interior%20with%20colorful%20decorations%2C%20bright%20glass%20windows%2C%20busy%20workers%2C%20comedic%20atmosphere%2C%20warm%20and%20vibrant%20lighting&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '超清',
    region: '中国大陆',
  },
  {
    id: 'movie-9',
    title: '寄生虫',
    year: 2019,
    category: 'rihan',
    subcategory: '剧情片',
    rating: 9.3,
    duration: '132分钟',
    director: '奉俊昊',
    cast: ['宋康昊', '李善均', '赵汝贞', '崔宇植'],
    description: '一家四口全是无业游民，直到长子靠着伪造文凭来到富豪朴社长家担任家教，两个天差地别的家庭开始了一段奇妙而危险的纠缠。',
    longDescription: '金基泽一家四口全是无业游民，生活在半地下室里。直到有一天，长子金基宇靠着伪造的文凭来到富豪朴社长家担任家教。两个天差地别的家庭开始了一段奇妙而危险的纠缠，随着一桩桩意外事件的发生，隐藏在光鲜背后的秘密逐渐浮出水面。这部获得奥斯卡最佳影片的韩国电影以独特的视角揭示了贫富差距的主题。',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20drama%20thriller%20movie%20poster%2C%20family%20standing%20in%20front%20of%20modern%20house%2C%20dark%20and%20moody%20atmosphere%2C%20minimalist%20design%2C%20black%20and%20green%20color%20scheme%2C%20award-winning%20film%20aesthetic&width=600&height=900&seq=movie-cover-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Modern%20luxury%20house%20on%20a%20hill%20contrasting%20with%20lower%20city%20area%2C%20Seoul%20urban%20landscape%2C%20dramatic%20contrast%20lighting%2C%20rain%20and%20moody%20atmosphere%2C%20cinematic%20Korean%20film%20style&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '蓝光',
    region: '韩国',
  },
  {
    id: 'movie-10',
    title: '奥本海默',
    year: 2023,
    category: 'oumei',
    subcategory: '剧情片',
    rating: 9.1,
    duration: '180分钟',
    director: '克里斯托弗·诺兰',
    cast: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙', '小罗伯特·唐尼'],
    description: '讲述了美国\'原子弹之父\'罗伯特·奥本海默领导曼哈顿计划制造原子弹的故事，以及他在战后受到的政治迫害。',
    longDescription: '影片讲述了美国"原子弹之父"罗伯特·奥本海默的生平。从他在剑桥的求学岁月，到领导曼哈顿计划制造世界上第一颗原子弹，再到战后因反对氢弹研发而受到政治迫害。诺兰以非线性的叙事结构，展现了这位天才物理学家内心的矛盾与挣扎，深度探讨了科学与道德、权力与责任的复杂关系。',
    coverImage: 'https://readdy.ai/api/search-image?query=Biographical%20drama%20movie%20poster%20about%20scientist%2C%20man%20in%20suit%20with%20hat%20against%20mushroom%20cloud%20explosion%2C%20black%20and%20white%20with%20orange%20fire%2C%20serious%20and%20dramatic%20tone%2C%20Oscar%20film%20aesthetic&width=600&height=900&seq=movie-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dramatic%20black%20and%20white%20atomic%20explosion%20mushroom%20cloud%20in%20desert%2C%20cinematic%20historical%20scene%2C%20intense%20orange%20fire%20and%20dark%20smoke%2C%20Christopher%20Nolan%20film%20style%2C%20epic%20historical%20drama&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '蓝光',
    region: '美国',
  },
  {
    id: 'movie-11',
    title: '你的名字',
    year: 2016,
    category: 'rihan',
    subcategory: '爱情片',
    rating: 9.0,
    duration: '106分钟',
    director: '新海诚',
    cast: ['神木隆之介', '上白石萌音', '长泽雅美', '市原悦子'],
    description: '生活在东京的男高中生立花泷和生活在乡下的女高中生宫水三叶在某天醒来后发现彼此互换了身体，一段跨越时空的恋爱故事就此展开。',
    longDescription: '生活在东京的男高中生立花泷和生活在乡下小镇的女高中生宫水三叶，在某天早上醒来后发现彼此互换了身体。两人在适应对方生活的过程中逐渐产生了感情，然而当他们想要寻找对方时，却发现了一个令人震惊的事实——他们的时间线相差了三年。新海诚以唯美的画面和动人的音乐，谱写了一曲跨越时空的青春恋歌。',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20romance%20movie%20poster%2C%20boy%20and%20girl%20reaching%20toward%20each%20other%20under%20starry%20sky%2C%20beautiful%20dreamy%20atmosphere%2C%20pastel%20colors%2C%20Makoto%20Shinkai%20film%20style&width=600&height=900&seq=movie-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dreamy%20twilight%20sky%20with%20comet%20and%20stars%20over%20Japanese%20rural%20landscape%2C%20purple%20and%20pink%20gradient%20sky%2C%20anime-style%20beautiful%20scenery%2C%20romantic%20atmosphere%2C%20Makoto%20Shinkai%20cinematic%20visual&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '蓝光',
    region: '日本',
  },
  {
    id: 'movie-12',
    title: '哥斯拉大战金刚2',
    year: 2024,
    category: 'oumei',
    subcategory: '科幻片',
    rating: 8.1,
    duration: '115分钟',
    director: '亚当·温加德',
    cast: ['丽贝卡·豪尔', '布莱恩·泰里·亨利', '丹·史蒂文斯', '凯莉·霍特尔'],
    description: '金刚与哥斯拉再度联手，对抗一个潜伏在地球空心世界中的巨大威胁——刀疤王，一场史诗级的怪兽大战即将爆发。',
    longDescription: '金刚与哥斯拉再度联手，对抗一个潜伏在地球空心世界中的巨大威胁——刀疤王。随着这位古老泰坦的苏醒，整个地球面临着前所未有的危机。金刚必须深入地球内部探索未知领域，而哥斯拉则在表面世界积蓄力量。两大泰坦巨兽将携手迎战，展开一场足以撼动星球的史诗对决。',
    coverImage: 'https://readdy.ai/api/search-image?query=Monster%20movie%20poster%20with%20giant%20gorilla%20and%20godzilla%20facing%20off%2C%20epic%20scale%2C%20destruction%20and%20fire%2C%20dark%20atmospheric%20lighting%2C%20blockbuster%20kaiju%20film%20design&width=600&height=900&seq=movie-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20battle%20between%20giant%20monsters%20in%20destroyed%20city%2C%20fire%20and%20explosions%2C%20massive%20scale%20cinematic%20scene%2C%20dark%20smoke%20and%20orange%20flames%2C%20Hollywood%20kaiju%20movie%20visual&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '4K',
    region: '美国',
  },
  {
    id: 'movie-13',
    title: '长津湖',
    year: 2021,
    category: 'huayu',
    subcategory: '战争片',
    rating: 9.0,
    duration: '176分钟',
    director: '陈凯歌、徐克、林超贤',
    cast: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    description: '以抗美援朝战争中的长津湖战役为背景，讲述了一段波澜壮阔的历史，在极寒严酷的环境下东线作战部队凭着钢铁意志和无畏精神奋勇杀敌。',
    longDescription: '1950年冬天，中国人民志愿军第9兵团在极度严寒中奔赴朝鲜战场长津湖地区。面对着装备精良、补给充足的美军王牌部队，志愿军战士们在零下40度的极寒中，穿着单薄的冬衣，啃着冻成冰块的土豆，以血肉之躯对抗钢铁洪流，用钢铁般的意志和无畏的战斗精神，书写了一段可歌可泣的英雄史诗。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20war%20film%20movie%20poster%2C%20soldiers%20in%20snowy%20battlefield%20winter%20setting%2C%20cold%20blue%20and%20white%20tones%2C%20heroic%20and%20serious%20atmosphere%2C%20historical%20epic%20war%20movie%20design&width=600&height=900&seq=movie-cover-13&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20winter%20battlefield%20with%20soldiers%20in%20snow%2C%20frozen%20mountain%20landscape%2C%20cold%20blue%20and%20white%20atmosphere%2C%20smoke%20and%20fire%20in%20distance%2C%20historical%20war%20cinematic%20scene&width=1600&height=700&seq=movie-banner-13&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '4K',
    region: '中国大陆',
  },
  {
    id: 'movie-14',
    title: '毒液3',
    year: 2025,
    category: 'oumei',
    subcategory: '科幻片',
    rating: 8.0,
    duration: '109分钟',
    director: '凯莉·马塞尔',
    cast: ['汤姆·哈迪', '朱诺·坦普尔', '切瓦特·埃加福特', '克拉克·巴茨科'],
    description: '埃迪·布洛克和毒液在他们的世界里被追杀，面临艰难的抉择，他们必须放下分歧携手对抗共同的敌人。',
    longDescription: '埃迪·布洛克和毒液在他们的世界里被一群来自外星的神秘组织追杀，同时还要面对另一位强大的共生体——毒素的威胁。面对前所未有的困境，这对不和谐的搭档必须放下彼此的分歧，携手对抗共同的敌人。影片以黑暗幽默的风格和精彩的动作场面，为毒液三部曲画下句点。',
    coverImage: 'https://readdy.ai/api/search-image?query=Anti-hero%20superhero%20movie%20poster%20with%20dark%20symbiote%20character%2C%20black%20goo%20and%20sharp%20teeth%2C%20dark%20and%20edgy%20design%2C%20menacing%20atmosphere%2C%20Marvel%20anti-hero%20film%20style&width=600&height=900&seq=movie-cover-14&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dark%20urban%20cityscape%20at%20night%20with%20black%20symbiote%20tendrils%2C%20moody%20neon%20lighting%2C%20rain-slicked%20streets%2C%20dark%20superhero%20movie%20atmosphere%2C%20edgy%20cinematic%20style&width=1600&height=700&seq=movie-banner-14&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '蓝光',
    region: '美国',
  },
  {
    id: 'movie-15',
    title: '深海',
    year: 2023,
    category: 'huayu',
    subcategory: '动画片',
    rating: 8.4,
    duration: '112分钟',
    director: '田晓鹏',
    cast: ['苏鑫', '王亭文', '滕奎兴', '杨婷'],
    description: '一个小女孩误入了一个梦幻般的深海世界，在这里她遇到了一个神秘的少年，两人一起踏上了寻找深海之眼的奇妙旅程。',
    longDescription: '女孩参宿误入了一个梦幻般的深海世界，这里的一切都与现实截然不同——海洋生物拥有人的情感，深海中隐藏着无数古老的秘密。在这里她遇到了神秘的少年南河，两人一起踏上了寻找深海之眼的奇妙旅程。田晓鹏导演以其独特的东方美学，创造了令人惊叹的深海幻境，用华丽的视觉呈现了一个关于成长与治愈的动人故事。',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20movie%20poster%2C%20girl%20diving%20into%20dreamy%20deep%20sea%20world%2C%20colorful%20underwater%20scene%2C%20magical%20and%20dreamlike%20atmosphere%2C%20particle%20effects%20and%20vibrant%20colors&width=600&height=900&seq=movie-cover-15&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Dreamlike%20underwater%20fantasy%20world%20with%20colorful%20sea%20creatures%2C%20flowing%20particle%20effects%2C%20vibrant%20blue%20and%20pink%20gradient%2C%20magical%20deep%20ocean%20atmosphere%2C%20Chinese%20animation%20film%20visual&width=1600&height=700&seq=movie-banner-15&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '4K',
    region: '中国大陆',
  },
  {
    id: 'movie-16',
    title: '芭比',
    year: 2023,
    category: 'oumei',
    subcategory: '喜剧片',
    rating: 8.3,
    duration: '114分钟',
    director: '格蕾塔·葛韦格',
    cast: ['玛格特·罗比', '瑞恩·高斯林', '亚美莉卡·费雷拉', '凯特·麦金侬'],
    description: '芭比因为这份\'不完美\'被逐出芭比乐园，她和肯来到现实世界寻找自我，却发现现实远非想象，一场充满粉色的冒险就此展开。',
    longDescription: '在芭比乐园里，一切都完美无缺。直到有一天，芭比突然开始思考死亡——这在芭比的世界里是前所未有的事。她因为这份"不完美"被逐出了芭比乐园，不得不和肯一起踏入现实世界。在这里，她发现现实远比想象中复杂，也开始了寻找真正自我的旅程。格蕾塔·葛韦格以充满讽刺的粉色寓言，让全世界重新认识了芭比。',
    coverImage: 'https://readdy.ai/api/search-image?query=Barbie%20movie%20poster%20with%20pink%20aesthetic%2C%20blonde%20woman%20in%20pink%20outfit%2C%20vibrant%20and%20playful%20design%2C%20nostalgic%20retro%20vibe%2C%20Hollywood%20comedy%20film%20poster%20style&width=600&height=900&seq=movie-cover-16&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Pink%20dreamy%20fantasy%20world%20with%20plastic%20houses%20and%20perfect%20landscape%2C%20bright%20vibrant%20colors%2C%20surreal%20toy%20world%20atmosphere%2C%20retro%201950s%20aesthetic%2C%20Barbie%20movie%20cinematic%20style&width=1600&height=700&seq=movie-banner-16&orientation=landscape',
    isHot: false,
    isNew: false,
    quality: '超清',
    region: '美国',
  },
];